// extracted by mini-css-extract-plugin
module.exports = {"container":"KS","noResults":"LS","contact":"MS"};